import type {
	AccountingAmount,
	SettlementStatus,
} from "@/company_admin/gql/__generated__/graphql"

/** ステータスの表示テキスト */
export const statusLabels: Record<SettlementStatus, string> = {
	PENDING: "保留中",
	CARRYOVER: "来月繰越",
	PAYOUT_IN_PROGRESS: "SOUHL 振込確認中",
	INVOICE_IN_PROGRESS: "御社支払い確認中",
	COMPLETED: "完了",
}

/** 調整金額の種別ラベル */
export const getAdjustmentLabel = (adj: AccountingAmount): string | null => {
	if (Number(adj.amount) === 0) return null
	return adj.isPayout ? "(SOUHL 振込)" : "(御社 支払い)"
}

/** payout 一括更新のターゲットステータスを決定 */
export const getPayoutTargetStatus = (
	currentStatus: SettlementStatus
): SettlementStatus | null => {
	if (currentStatus === "PENDING") return "PAYOUT_IN_PROGRESS"
	if (currentStatus === "PAYOUT_IN_PROGRESS") return "COMPLETED"
	return null
}

/** invoice 一括更新のターゲットステータスを決定 */
export const getInvoiceTargetStatus = (
	currentStatus: SettlementStatus
): SettlementStatus | null => {
	if (currentStatus === "PENDING") return "INVOICE_IN_PROGRESS"
	if (currentStatus === "INVOICE_IN_PROGRESS") return "COMPLETED"
	return null
}
